export const STICKY_BANNER_TEST_ID = "sticky-banner";
